'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _productActivation = require('ui-addon-upgrades/_core/common/constants/productActivation');

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

var _connectedUpgradeDataPropsInterface = require('ui-addon-upgrades/_core/common/data/upgradeData/interfaces/connectedUpgradeDataPropsInterface');

var _connectedUpgradeDataPropsInterface2 = _interopRequireDefault(_connectedUpgradeDataPropsInterface);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProductActivationWrapper = function ProductActivationWrapper(WrappedComponent) {
  var ProductActivationWrapperHOC = function ProductActivationWrapperHOC(props) {
    var upgradeProduct = props.upgradeData.upgradeProduct;

    var isProductActivationWrapperProduct = _productActivation.productActivationProducts.indexOf(upgradeProduct) !== -1;

    if (!isProductActivationWrapperProduct) {
      _devLogger2.default.warn({
        message: 'ProductActivationWrapper: Expected upgradeProduct to be one of ' + _productActivation.productActivationProducts,
        key: 'ProductActivationWrapper'
      });

      return null;
    }

    return _react2.default.createElement(WrappedComponent, props);
  };

  ProductActivationWrapperHOC.propTypes = _connectedUpgradeDataPropsInterface2.default;

  return ProductActivationWrapperHOC;
};

exports.default = ProductActivationWrapper;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/common/components/ProductActivationWrapper.js
// module id = 648
// module chunks = 3 4